/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItem} from './AsideMenuItem'
import {SelectClass} from '../../../../components/SelectClass'
import {UiIcon} from '../../../../components/UiIcon'
import React from 'react'
import {AsideUserMenu} from '../../../partials/layout/aside-menus/AsideUserMenu'

export function AsideMenuMain() {
  return (
    <>
      <SelectClass />
      <AsideMenuItem to='/homework/create' title='Sorumluluk ata' fontIcon='bi-plus-square' variant='primary'/>
      <div className='aside-nav-group' role='group' aria-labelledby='aside-class-title'>
      <h2 className='menu-section' id='aside-class-title'>Sınıf yönetimi</h2>
      <AsideMenuItem
        to='/dashboard'
        title='Sınıfım'
        fontIcon='bi-grid'
      />
      <AsideMenuItem
        to='/student'
        title='Öğrencilerim'
        fontIcon='bi-people'
      />
      <AsideMenuItem
        to='/homework'
        title='Sorumluluk geçmişi'
        fontIcon='bi-clock-history'
      />
      </div>
      <div className='aside-nav-group' role='group' aria-labelledby='aside-library-title'>
      <h2 className='menu-section' id='aside-library-title'>Kaynaklar</h2>
      <AsideMenuItem
        to='/curriculum'
        title='Kitaplıklarım'
        fontIcon='bi-book'
      />
      <AsideMenuItem to='/activities' title='Etkinlikler' fontIcon='bi-puzzle'/>
      <AsideMenuItem
        to='/curriculum/0'
        title='Kitaplık ekle'
        fontIcon='bi-journal-plus'
      />
      </div>
      <div className='aside-account'>
        <div id='kt_aside_user'><AsideUserMenu/></div>
        <button type='button' className='aside-logout-button' aria-label='Oturumu kapat' onClick={() => {
          localStorage.clear()
          window.location.href = '/auth'
        }}>
          <UiIcon name='logout' size={18}/>
          <span>Çıkış Yap</span>
        </button>
      </div>
    </>
  )
}
